/* eslint-disable */
export default {
  noActiveCalls: 'No hay ninguna llamada activa',
  currentCall: 'Llamada actual',
  ringCall: 'Llamada sonando',
  onHoldCall: 'Llamada en espera',
  otherDeviceCall: 'Llamadas en curso en mis otros dispositivos',
  confirmation: 'Confirmación',
  confirmMergeToConference: '¿Añadir a la llamada de conferencia?',
  mergeToConference: 'Combinar',
  conferenceCall: 'Llamada de conferencia',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
